import addClass from './addClass';
import hasClass from './hasClass';
import removeClass from './removeClass';

const replaceClass = function (ele, oldClass, newClass) {
    if (ele) {
        if (hasClass(ele, oldClass)) {
            removeClass(ele, oldClass);
            addClass(ele, newClass);
        } else {
            addClass(ele, newClass);
        }
    }
};
export default replaceClass;
